import { render } from "./backHome.vue?vue&type=template&id=492bc35a"
import script from "./backHome.vue?vue&type=script&lang=js"
export * from "./backHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__